<template>
  <div></div>
</template>

<script>
import { StatusEmitterMixin } from '@/mixins/Booking/StatusEmitterMixin'
import { EventSearchMixin } from '@/mixins/Booking/EventSearchMixin'
import { SelectedDateMixin } from '@/mixins/Booking/SelectedDateMixin'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'

export default {
  name: 'ResourceEventConflict',
  mixins: [StatusEmitterMixin, EventSearchMixin, SelectedDateMixin, SiteBookingSettingMixin],
  props: {
    timeSlot: Object,
    resourceId: String,
    value: Object
  },
  computed: {
    resourceEvents () {
      return this.events ? this.events.filter(a => a.resourceId === this.resourceId) : []
    },
    conflictingEvent () {
      // Check for any event where the endTime of timeSlot is within the startUtc and endUtc
      // or the startTime of timeSlot is within the startUtc and endUtc
      // or where an event is within the startTime and endTime of timeSlot
      return this.resourceEvents.find(event => {
        const startUtc = new Date(event.startUtc).getTime()
        const endUtc = new Date(event.endUtc).getTime()
        const timeSlotStartTime = new Date(this.timeSlot.startTime).getTime()
        const timeSlotEndTime = new Date(this.timeSlot.endTime).getTime()

        return (startUtc < timeSlotEndTime && timeSlotEndTime < endUtc) ||
          (startUtc < timeSlotStartTime && timeSlotStartTime < endUtc) ||
          (timeSlotStartTime <= startUtc && endUtc <= timeSlotEndTime)
      })
    },
    loading () {
      return this.loadingEvents
    },
    available () {
      return !this.loading && !this.conflictingEvent && !this.retryEvents
    }
  }
}
</script>
